import { render, staticRenderFns } from "./PageUpdate.vue?vue&type=template&id=c344c1aa&"
import script from "./PageUpdate.vue?vue&type=script&lang=js&"
export * from "./PageUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PageUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports